import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import ModalMenu from "../../components/Modal/ModalMenu";
import ModalSearch from "../../components/Modal/ModalSearch";
import LiquidityComponent from "../../components/Swych/LiquidityComponent";

const Liquidity = () => {
    return (
        <div className="main">
            <Header />
            <LiquidityComponent/>
            <Footer />
            <ModalSearch />
            <ModalMenu />
        </div>
    )

}
export default Liquidity;